import React  from 'react'
import Popover from "../../../../../gd-components/gd-popover/popover-v2";
import {findDOMNode} from "react-dom";
import PopoverPosition from "../../../../../gd-components/gd-popover/popover-position";
import TaskType from "../../../../../model2/task-type/task-type";
import IconSelector from "../../../../../gd-components/selector/icon-selector/icon-selector";
import FieldProto from "../../../../proto/field-proto";
import {TaskIconCategory} from "../../../../../gd/const/item-icon/task-categories";
import {IconType} from "../../../../../gd-components/selector/icon-selector/@const";

type Props = {
    field       : FieldProto
    value       : string
    parent      : any
    hidePopover : callback
    onChange    : callback
}

export default function FieldIcon_Popover(props: Props) {

    const onChange = (taskType: TaskType, icon: string)=> {
        props.onChange(taskType, icon)
        props.parent.hidePopover()
    }

    const iconCategories: TaskIconCategory[] = props.field.fieldParams.iconCategories ? props.field.fieldParams.iconCategories : []
    const iconTypes: IconType[] = props.field.fieldParams.iconTypes ? props.field.fieldParams.iconTypes : []

    return (
        <Popover position                = {PopoverPosition.bottomCenter()}
                 className               = "cursor-default border-box"
                 popoverClass            = "gd-select-parent-popover-new"
                 getTargetFunc           = {()=>findDOMNode(props.parent)}
                 outsideClickIgnoreClass = "option"
                 onClickOutside          = {()=>{props.parent.hidePopover()}}>

            <IconSelector icon              = {props.value}
                          iconCategories    = {iconCategories}
                          iconTypes         = {iconTypes}
                          onChange          = {onChange}/>

        </Popover>
    )
}
